import { configureStore } from "@reduxjs/toolkit";
import licenseReducer from "./license-slice";
import userReducer from "./user-slice";
import dialogUnreadReducer from "./dialog-unread-slice";

const store = configureStore({
  reducer: {
    license: licenseReducer,
    user: userReducer,
    dialogUnread: dialogUnreadReducer
  }
});

export default store;
